import { ArrowPathIcon, ArrowTopRightOnSquareIcon, ExclamationCircleIcon, PhoneIcon, UserIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
interface InitialRSVPCheckFormProps {
  onSubmit: (name: string, phone: string) => void;
  errors?: { familyName?: string; phoneNumber?: string };
  loading?: boolean;
}
const InitialRSVPCheckForm: React.FC<InitialRSVPCheckFormProps> = ({ onSubmit, errors, loading }) => {
  const [familyName, setFamilyName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(familyName, phoneNumber);
  };

  return (
    <div className="min-h-[85vh] flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Event Access</h2>
          <p className="text-gray-600">Please verify your details to view the event</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Organizer Name <span className="text-red-500">*</span>
            </label>
            <div className={`flex items-center gap-2 p-2 rounded-lg border ${errors?.familyName ? 'border-red-500' : 'border-gray-200'
              } focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200`}>
              <UserIcon className="w-5 h-5 text-gray-400 ml-2" />
              <input
                type="text"
                placeholder="Enter Organizer Name"
                value={familyName}
                onChange={(e) => setFamilyName(e.target.value)}
                className="flex-1 outline-none bg-transparent py-2 border-none focus:border-transparent focus:ring-0"
                disabled={loading}
              />
            </div>
            {errors?.familyName && (
              <p className="text-red-500 text-sm mt-1 flex items-center gap-1">
                <ExclamationCircleIcon className="w-4 h-4" />
                {errors.familyName}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Mobile Number <span className="text-red-500">*</span>
            </label>
            <div className={`flex items-center gap-2 p-2 rounded-lg border ${errors?.phoneNumber ? 'border-red-500' : 'border-gray-200'
              } focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200`}>
              <PhoneIcon className="w-5 h-5 text-gray-400 ml-2" />
              <input
                type="tel"
                placeholder="Enter 10-digit number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                className="flex-1 outline-none bg-transparent py-2 border-none focus:border-transparent focus:ring-0"
                disabled={loading}
              />
            </div>
            {errors?.phoneNumber && (
              <p className="text-red-500 text-sm mt-1 flex items-center gap-1">
                <ExclamationCircleIcon className="w-4 h-4" />
                {errors.phoneNumber}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-75"
          >
            {loading ? (
              <ArrowPathIcon className="w-5 h-5 animate-spin" />
            ) : (
              <ArrowTopRightOnSquareIcon className="w-5 h-5" />
            )}
            {loading ? 'Checking...' : 'View Event'}
          </button>
        </form>
      </div>
    </div>
  );
};
export default InitialRSVPCheckForm